import HeroChat from "@/components/chat/HeroChat";
import TrustMarqueeStrip from "@/components/public/home/TrustMarqueeStrip";
import ServicesTimeline from "@/components/public/home/ServicesTimeline";
import ProcessWithVideos from "@/components/public/home/ProcessWithVideos";
import FounderSection from "@/components/public/home/FounderSection";
import BlogTimeline from "@/components/public/home/BlogTimeline";
import MegaCTA from "@/components/public/home/MegaCTA";
import { SEO, organizationJsonLd, websiteJsonLd } from "@/lib/seo";

const Home = () => {
    return (
        <>
            <SEO
                title="TRBD — حلول رقمية لتطوير الأعمال"
                description="نبني منصات رقمية متكاملة: متاجر، تطبيقات، وأنظمة إدارة. أكثر من 45 مشروعاً و102 عميلاً حول العالم."
                path="/"
                keywords={[
                    "TRBD",
                    "تطوير مواقع",
                    "تطبيقات جوال",
                    "حلول رقمية",
                    "تصميم متاجر إلكترونية",
                    "أحمد اللولو",
                    "Kasioon",
                    "CarWhats",
                ]}
                jsonLd={[organizationJsonLd(), websiteJsonLd()]}
            />
            <div className="relative z-10 flex flex-col">
                <HeroChat />
                <TrustMarqueeStrip />
                <ServicesTimeline />
                <ProcessWithVideos />
                <FounderSection />
                <BlogTimeline />
                <MegaCTA />
            </div>
        </>
    );
};

export default Home;
